import { Aperture, ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#070707]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
          <div>
            <button
              onClick={() => scrollToId("top")}
              className="flex items-center gap-2.5"
              data-testid="footer-logo"
            >
              <Aperture className="h-5 w-5 text-[#D4AF37]" strokeWidth={1.5} />
              <span className="font-display text-lg font-bold tracking-tight text-[#F5F5F5]">
                pitsora
              </span>
            </button>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-[#666666]">
              From Research to Documentary.
            </p>
          </div>

          <nav className="flex items-center gap-8" aria-label="Footer">
            <a
              href="mailto:hello@pitsora"
              className="group flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.25em] text-[#9A9A9A] transition-colors duration-300 hover:text-[#D4AF37]"
              data-testid="footer-contact"
            >
              Contact
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </nav>
        </div>

        <div className="mt-14 flex flex-col justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row sm:items-center">
          <span className="font-mono text-[10px] tracking-[0.2em] text-[#555555]" data-testid="footer-copyright">
            © 2026 pitsora. All rights reserved.
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#555555]">
            Built for storytellers. <span className="text-[#D4AF37]">Powered by AI.</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
